import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "backdrop", "closeButton", "navbar"]

  connect() {
    // Hide navbar by default
    this.hide()
    this.closeButtonTarget.addEventListener('keydown', this.handleKeydown.bind(this))
  }

  disconnect() {
    // Clean up event listeners
    this.closeButtonTarget.removeEventListener('keydown', this.handleKeydown.bind(this))
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.hide()
    }
  }

  show() {
    this.containerTarget.classList.remove("hidden")

    // Make the backdrop visible but still transparent
    this.backdropTarget.classList.remove("hidden")
    this.backdropTarget.classList.add("opacity-0")

    // Force a reflow to ensure the transition works
    this.backdropTarget.offsetHeight

    // Now transition to fully visible
    this.backdropTarget.classList.remove("opacity-0")
    this.backdropTarget.classList.add("opacity-100")

    // Make the close button visible but still transparent
    this.closeButtonTarget.classList.remove("hidden")
    this.closeButtonTarget.classList.add("opacity-0")

    // Force a reflow to ensure the transition works
    this.closeButtonTarget.offsetHeight

    // Now transition to fully visible
    this.closeButtonTarget.classList.remove("opacity-0")
    this.closeButtonTarget.classList.add("opacity-100")

    // Add a small delay before removing the translate class to allow the transition to work
    setTimeout(() => {
      this.navbarTarget.classList.remove("-translate-x-full")
    }, 10)
    document.body.classList.add("overflow-hidden")
  }

  hide() {
    // Start fading out the backdrop
    this.backdropTarget.classList.add("opacity-0")
    this.backdropTarget.classList.remove("opacity-100")

    this.closeButtonTarget.classList.add("opacity-0")
    this.closeButtonTarget.classList.remove("opacity-100")
    this.navbarTarget.classList.add("-translate-x-full")

    document.body.classList.remove("overflow-hidden")
    // Add a small delay before hiding the container to allow the transition to complete
    setTimeout(() => {
      this.containerTarget.classList.add("hidden")
      this.backdropTarget.classList.add("hidden")
      this.closeButtonTarget.classList.add("hidden")
    }, 300)
  }

  toggle() {
    if (this.containerTarget.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide()
    }
  }
}
